import { useLocale } from 'hooks/useLocale/useLocale';
import { useIsExactPath } from 'hooks/useIsExactPath/useIsExactPath';
import { AppRouteWithParams } from 'routing/AppRoute.enum';

import { StatusTableItemProps, StatusText } from './StatusTableItem.types';
import * as Styled from './StatusTableItem.styles';

export const StatusTableItem = ({ status, disabled, textBold, smallFontSize, ...props }: StatusTableItemProps) => {
  const { formatMessage } = useLocale();

  const isOwnerHistoryView = useIsExactPath(AppRouteWithParams.ownerHistory.path);

  const statusText: StatusText = {
    OK: 'devices.readers.status.ok',
    NOWY: 'devices.readers.status.new',
    PODMIENIONY: 'devices.readers.status.replaced',
    AWARIA: 'devices.readers.status.failure',
    USUNIETY: 'devices.readers.status.deleted',
    DOSTEPNA: 'card.status.available',
    WYDANA: 'card.status.released',
    WYDANA_Z: 'card.status.releasedWithReturnDate',
    AKTYWNY: 'user.status.active',
    NIEAKTYWNY: 'user.status.inactive',
    ZABLOKOWANO: isOwnerHistoryView ? 'owner.history.action.locked' : 'history.status.blocked',
    ODBLOKOWANO: isOwnerHistoryView ? 'owner.history.action.unlocked' : 'history.status.unblocked',
    ZWROCONO: isOwnerHistoryView ? 'owner.history.action.returned' : 'history.status.returned',
    WYDANO: isOwnerHistoryView ? 'owner.history.action.issued' : 'history.status.issued',
    ZARCHIWIZOWANO: 'history.status.archived',
    PRZYWROCONO: 'history.status.restored',
    DODANO: 'history.status.added',
    ZEDYTOWANO: 'history.status.edited',
    USUNIETO: 'history.status.removed',
    ZALOGOWANO: 'history.status.logged',
    WYLOGOWANO: 'history.status.logout',
  };

  return (
    <Styled.Container {...props}>
      <Styled.Dot $status={status} $disabled={disabled}></Styled.Dot>
      <Styled.Text $textBold={textBold} $smallFontSize={smallFontSize}>
        {formatMessage({ id: statusText[status] })}
      </Styled.Text>
    </Styled.Container>
  );
};
